module.exports = __webpack_public_path__ + "static/media/ic-streaming.d6b92e49.png";